


export class ThemedLotsView {

    constructor() {

        this.id = 'themed-lots';
		
		this.box = document.getElementById(this.id);
		if (!this.box) {
			return false;
		}
		
		this.title = this.box.querySelector('.sc_title > strong');
		this.ul = this.box.querySelector('.ul');
		
		this.liTemplate = this.ul.querySelector('.li')?.cloneNode();	
		this.itemTemplate = this.ul.querySelector('.lot')?.cloneNode(true);
    }

    render(state) { 

        if (!this.box) { return false;}
		
		if (state.title) { this.title.textContent = state.title;}
		
		if (state.data) {
			
			state.data.sort(() => Math.random() - 0.5);

			const dummies = this.ul.querySelectorAll('.lot.dummy');
			dummies.forEach((el, index) => {
				
				const data = state.data[index];

				if (!data) {
					el.parentElement.remove();
					return;
				}
				
				el.dataset.id = data.id;
				
				const titleLink = el.querySelector('a.title');
				titleLink.href = data.url;
				
				el.querySelector('a.preview').href = data.url;
				
				const img = el.querySelector('img');
				if (img) {
					img.src = data.image;
					img.dataset.src = data.image;
					img.alt = data.title || '';
				}

				titleLink.textContent = data.title;

				el.querySelector('.price p').textContent = data.price;
				el.querySelector('.price span').textContent = data.currency;

				el.classList.remove('dummy');
			});

			this.ul.querySelectorAll('.li').forEach((li) => {
				if (!li.textContent.trim() && li.children.length === 0) { li.remove();}
			});
			
			this.box.style.display = (this.ul.querySelector('.li')) ? '' : 'none';
			
			this.box.classList.remove('dummy');
		}
    }
}